import { useEffect, useState } from 'react';
import { getFeaturedResources } from '../../utils/utils';
import { Link } from 'react-router-dom';
import { decodeHtml } from '../guidebooks/FeaturedGuidebooks';

let FeaturedResources = () => {
  let [featuredResources, setFeaturedResources] = useState([]);

  useEffect(() => {
    async function fetch() {
      let featuredResources = await getFeaturedResources();
      setFeaturedResources(featuredResources);
    }
    fetch();
  }, []);

  return (
    <div className="featured">
      <h2>Featured Resources</h2>
      <div className="grid grid-cols-3 gap-3">
        {featuredResources.length > 0 &&
          featuredResources.map((resource) => (
            <div
              className="resource col-span-3 mt-3 lg:col-span-1"
              key={resource.id}
            >
              <Link reloadDocument to={`/library/resources/${resource.slug}`}>
                <h4 className="mt-0">{decodeHtml(resource.title.rendered)}</h4>
              </Link>
              <div
                dangerouslySetInnerHTML={{
                  __html: resource.excerpt.rendered,
                }}
              ></div>
              <Link reloadDocument to={`/library/resources/${resource.slug}`}>
                <span>Read More</span>
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FeaturedResources;
